module.exports = __webpack_public_path__ + "static/media/FT-FONDO-IMPRESION-3D.4c691046.jpg";